import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { bookAppointmentOnSurveyLinkClick } from '../../data-layer/actions.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '../../pages/BookAppointment/queries/get-book-appointment-store.js';
import '../../pages/BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../../pages/BookAppointment/queries/get-book-appointment-type.js';
import useVirtualAppointment from '../../pages/BookAppointment/hooks/use-virtual-appointment.js';
import AppointmentSurvey from './AppointmentSurvey.js';

const AppointmentSurveyContainer = (props)=>{
    const { getLabel  } = useIntl();
    const [, { type , appointment , store , timeSlot  }] = useAppointmentContext();
    const { featureConfigs  } = useFeatureToggles();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const labels = React.useMemo(()=>({
            title: getLabel('appointments.component.appointmentSurvey.title'),
            description: getLabel('appointments.component.appointmentSurvey.description'),
            cta: getLabel('appointments.component.appointmentSurvey.cta')
        })
    , [
        getLabel
    ]);
    const surveyUrl = React.useMemo(()=>{
        var ref, ref1;
        if (!type || !(appointment === null || appointment === void 0 ? void 0 : appointment.id) || (appointment === null || appointment === void 0 ? void 0 : appointment.isReservation)) {
            return;
        }
        /*
      We need to check if the appointmentBookingSurveyLinksStoreCodes config
      is even set in the first place. If it's not set, then continue as usual
      by displaying the survey.
    */ if (featureConfigs.appointmentBookingSurveyLinksStoreCodes && !((ref = featureConfigs.appointmentBookingSurveyLinksStoreCodes) === null || ref === void 0 ? void 0 : ref.find((code)=>{
            return Number(code) === (store === null || store === void 0 ? void 0 : store.code);
        }))) {
            return;
        }
        const appointmentBookingSurveyConfig = (ref1 = featureConfigs.appointmentBookingSurveyLinks) === null || ref1 === void 0 ? void 0 : ref1.find((appointmentBookingSurveyLink)=>{
            return appointmentBookingSurveyLink[0] === (type === null || type === void 0 ? void 0 : type.id);
        });
        if (appointmentBookingSurveyConfig) {
            var ref2;
            return (ref2 = appointmentBookingSurveyConfig[1]) === null || ref2 === void 0 ? void 0 : ref2.replace(`{appointmentId}`, appointment.id);
        }
    }, [
        appointment,
        type,
        featureConfigs.appointmentBookingSurveyLinks,
        featureConfigs.appointmentBookingSurveyLinksStoreCodes,
        store === null || store === void 0 ? void 0 : store.code, 
    ]);
    const onSurveyLinkClick = React.useCallback(()=>{
        if (store && type && timeSlot && appointment) {
            const dataLayerEvent = bookAppointmentOnSurveyLinkClick({
                store: !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    globalStoreId: store.globalStoreId,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: {
                    id: appointment === null || appointment === void 0 ? void 0 : appointment.id,
                    appointmentType: {
                        id: type.id,
                        ageGroup: type.ageGroup,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                }
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        store,
        type,
        timeSlot,
        appointment,
        isVirtualAppointmentType
    ]);
    if (!surveyUrl) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(AppointmentSurvey, swcHelpers.extends({}, props, {
        labels: labels,
        surveyUrl: surveyUrl,
        onClick: onSurveyLinkClick
    }));
};

export { AppointmentSurveyContainer as default };
//# sourceMappingURL=AppointmentSurveyContainer.js.map
